import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { ThemeProvider } from '@material-ui/core';
import { createBrowserHistory } from 'history';
import React from 'react';
import ReactDOM from 'react-dom';
import '@dazn/dx-components/styles/index.scss';
import { initialize } from 'react-ga';
import { Router } from 'react-router-dom';

import App from './App';
import { CriticalErrorBoundary, ErrorCatcher } from './components/ErrorBoundary';
import { GlobalMessages } from './components/GlobalMessages';
import authConfig from './config/auth';
import muiTheme from './muiTheme';
import * as serviceWorker from './serviceWorker';

initialize(String(process.env.REACT_APP_GA_ID));

const pca = new PublicClientApplication({ auth: authConfig });

const history = createBrowserHistory();

ReactDOM.render(
  <CriticalErrorBoundary>
    <GlobalMessages>
      <ErrorCatcher />
      <MsalProvider instance={pca}>
        <Router history={history}>
          <ThemeProvider theme={muiTheme}>
            <App />
          </ThemeProvider>
        </Router>
      </MsalProvider>
    </GlobalMessages>
  </CriticalErrorBoundary>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
